import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LocalePreferences from '/@/components/locale-preferences';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { resetProductSelection } from '/@/store/catalog/actions';
import { getCatalogBrands } from '/@/store/catalog/selectors';
import { setSelectedFeature } from '/@/store/nav/actions';
import { setPreferences } from '/@/store/session/actions';
import { getSessionCountry, getSessionLanguage } from '/@/store/session/selectors';
import { isMobile } from '/@/utils';
import { reverse } from '/@/utils/router';
import BaseBrandSelection from '/@/v3/components/brand-selection';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@connect(
    (state) => ({
        brands: getCatalogBrands(state),
        country: getSessionCountry(state),
        language: getSessionLanguage(state),
    }),
    (dispatch) => bindActionCreators({ resetProductSelection, setPreferences, setSelectedFeature }, dispatch)
)
@autobind
export default class Catalog extends Component {
    static contextTypes = {
        history: PropTypes.object,
    };

    static propTypes = {
        onClick: PropTypes.func,
    };

    handleClickCatalogItem(type) {
        this.props.resetProductSelection();
        this.props.setSelectedFeature({ view: 'catalog.ProductSelection', selectedFeature: 'catalog' });
        this.context.history(
            reverse('catalog.ProductSelection', {
                params: { type },
            })
        );
    }
    render() {
        return (
            <div className={styles.root}>
                <div className={styles.header}>
                    <span id={styles.icon} onClick={this.props.onClick} className='material-icons'>
                        arrow_back
                    </span>
                    {!isMobile() ? (
                        <div className={classNames(styles.logo, styles[`theme-${settings.app.theme}`])} />
                    ) : (
                        <LocalePreferences
                            openUp
                            appearance='row'
                            showLabels={false}
                            country={this.props.country.id}
                            language={this.props.language}
                            onChange={this.props.setPreferences}
                            showCountry
                            handleCountryChange={() => {}}
                            handleLanguageChange={() => {}}
                            showLanguage={false}
                        />
                    )}
                </div>
                <div className={styles.title}>
                    <Title color='primary' bolder theme={settings.app.theme} className={styles.catalogTitle}>
                        {_('Catálogo')}
                    </Title>
                    <Title color='light' size='md' className={styles.description}>
                        {_(
                            'Selecciona una de las marcas para poder acceder a todos los productos que tu lote pueda necesitar.'
                        )}
                    </Title>
                </div>
                <div>
                    <BaseBrandSelection brands={this.props.brands} onClick={this.handleClickCatalogItem} isLogin />
                </div>
            </div>
        );
    }
}
